import Vue from 'vue';
import moment from 'moment';

const success = (response, context) => {
  context.rentals = response.data.rentals;
  context.website_settings = response.data.website_settings;
  context.loading = false;
};

const failed = (context) => {

};

export default (context, params) => {
  const startDate = params.startDate === '' ? params.startDate : moment(params.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
  const endDate = params.endDate === '' ? params.endDate : moment(params.endDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
  return Vue.$http.get(`/get-available-rentals/${params.webKey}?&start_date=${startDate}&end_date=${endDate}
  &adult_count=${params.adultsNumber}&child_count=${params.childrenNumber}
  &group_names=${params.groupNames}`).then((response) => {
    if (response && response.status === 200) {
      success(response, context);
    }
  })
    .catch((error) => {
      failed(context, error);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/getUserRentals.js